<template>
  <v-card flat>
    <v-tabs
      fixed-tabs
      background-color="primary"
      show-arrows
    >
      <v-tab>
        PERSONAL INFORMATION
      </v-tab>
      <v-tab>
        ENTERPRISE INFORMATION
      </v-tab>
      <v-tab>
        LOCATION/FARM INFORMATION
      </v-tab>
      <v-tab-item>
        <v-card flat color="background" class="mt-2">
          <v-row justify="center">
            <v-col
              cols="12"
              md="4"
            >
              <v-card>
                <div class="h2 px-4 pt-4 font-weight-bold">
                  Bio
                </div>
                <v-row>
                  <v-col class="pa-6" cols="12" align="center">
                    <v-card class="image-card">
                      <v-img
                      :src= "`https://akfimsimages.s3.us-east-2.amazonaws.com/${farmer.photo}`"
                      class="image-card"
                    ></v-img>
                    </v-card>
                  </v-col>
                </v-row>
                <v-form>
                  <v-container class="px-4">
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="farmer.first_name"
                          label="First Name"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="farmer.last_name"
                          label="Last Name"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              md="8"
            >
              <v-card>
                <div class="h2 px-4 pt-4 font-weight-bold">
                  Identity
                </div>
                <v-form>
                  <v-container class="px-4">
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.reg_no"
                          label="Registration No"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.voters_card_no"
                          label="Identification Number"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.next_of_kin"
                          label="Next of Kin"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.edu_qua"
                          label="Education Qualification"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmer.phone"
                          label="Phone"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmer.age"
                          label="Age"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmer.gender"
                          label="Gender"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <div class="h2 pt-4 pb-2 font-weight-bold">
                      Address
                    </div>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmer.village"
                          label="Village"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmer.state"
                          label="State"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmer.lga"
                          label="Lga"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-combobox
                          v-model="challenges"
                          label="Challenges"
                          outlined
                          chips
                          multiple
                          append-icon=""
                        >
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
      <!--entrprise information///////////////////////-->
      <v-tab-item v-if="!loading">
        <v-card flat color="background" class="mt-2">
          <v-row>
            <v-col
              cols="12"
              md="8"
            >
              <v-card>
                <div class="h2 px-4 pt-4 font-weight-bold">
                  Enterprise Information
                </div>
                <v-form>
                  <v-container class="px-4">
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.crop_type"
                          label="Crop Type"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.crop_size"
                          label="Crop Size"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.livestock_type"
                          label="Livestock Type"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.livestock_size"
                          label="Livestock Size"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.fish_type"
                          label="Fish Type"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.fish_size"
                          label="Fish Size"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.planting_season"
                          label="Planting Season"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.harvest_season"
                          label="Harvest Season"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <div class="h2 pt-4 pb-2 font-weight-bold">
                      Financial Information
                    </div>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.business_name"
                          label="Business Name"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.avg_monthly_income"
                          label="Avg Monthly Income"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmer.bank_name"
                          label="Bank Name"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmer.account_name"
                          label="Account Name"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmer.account_num"
                          label="Account Number"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card>
            </v-col>
            <!--others-/////////////////////////////////////////////////-->
            <v-col>
              <v-card>
                <div class="h2 px-4 pt-4 font-weight-bold">
                  Other Information
                </div>
                <v-form>
                  <v-container class="px-4">
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="farmer.year_harvest_estimate"
                          label="Yearly Harvest Estimate"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-combobox
                          v-model="input_source"
                          label="Input source"
                          outlined
                          chips
                          multiple
                          append-icon=""
                        >
                        </v-combobox>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-combobox
                          v-model="processing"
                          label="Processing"
                          outlined
                          chips
                          multiple
                          append-icon=""
                        >
                        </v-combobox>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-combobox
                          v-model="market"
                          label="Market"
                          outlined
                          chips
                          multiple
                          append-icon=""
                        >
                        </v-combobox>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-combobox
                          v-model="farming_types"
                          label="Farming Types"
                          outlined
                          chips
                          multiple
                          append-icon=""
                        >
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
      <!--farm information//////////////////////////-->
       <v-tab-item>
        <v-card flat color="background" class="mt-2">
          <v-row>
            <v-col
              cols="12"
              md="8"
            >
              <v-card>
                <div class="h2 px-4 pt-4 font-weight-bold">
                  Location/Farm Info
                </div>
                <v-form>
                  <v-container class="px-4">
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="farmer.farm_address"
                          label="Farm Address"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.farms_lga"
                          label="Farm Lga"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.farms_village"
                          label="Farm Village"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.no_male_emp"
                          label="Male Emp"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.no_female_emp"
                          label="Female Employee"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.avg_emp_age"
                          label="Avg Employee Age"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmer.soil_condition"
                          label="Soil Condition"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <div class="h2 pt-4 pb-2 font-weight-bold">
                      Community Information
                    </div>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmer.village_head_phone"
                          label="Village Head Name"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmer.village_head_phone"
                          label="Village Head Phone"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmer.insurance_cover"
                          label="Insurance Cover?"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card>
            </v-col>
            <!--others-/////////////////////////////////////////////////-->
            <v-col>
              <v-card>
                <div class="h2 px-4 pt-4 font-weight-bold">
                  Field Information
                </div>
                <v-form>
                  <v-container class="px-4">
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="farmer.location"
                          label="Farm Location"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="farmer.plot_gps"
                          label="Plot GPS"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="farmer.corpo_assos"
                          label="Corperative society"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-combobox
                          v-model="funding"
                          label="Funding"
                          outlined
                          chips
                          multiple
                          append-icon=""
                        >
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import FarmerService from '../services/AkfimsFarmerService'

export default {
  name: 'Farmer',
  data () {
    return {
      farmer: {},
      challenges: '',
      input_source: '',
      farming_types: '',
      processing: '',
      market: '',
      funding: '',
      loading: false
    }
  },
  async created () {
    this.loading = true
    const id = this.$route.params.id
    const farmer = await FarmerService.getFarmer(id)
    const challenge = farmer.challenges
    this.challenges = JSON.parse(challenge)
    this.input_source = JSON.parse(farmer.input_source)
    this.farming_types = JSON.parse(farmer.farming_types)
    this.processing = JSON.parse(farmer.processing)
    this.market = JSON.parse(farmer.market)
    this.funding = JSON.parse(farmer.funding)
    this.farmer = farmer
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
.image-card{
  height: 300px;
  width: 300px
}
@media(max-height: 640px) {
  .image-card{
    height: 250px;
    width: 250px
  }
}
@media(max-height: 740px) and (min-height: 641px) {
  .image-card{
    height: 250px;
    width: 250px
  }
}
@media(max-height: 840px) and (min-height: 741px) {
  .image-card{
    height: 300px;
    width: 300px
  }
}
</style>
